import React, { useEffect, useState } from 'react';
import { Paper, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from '@mui/material';
import axios from 'axios';

const LANDLORD_API_BASE_URL = 'https://bunnyrent-backend-917484933271.us-central1.run.app/api';
const landlordApi = axios.create({
  baseURL: LANDLORD_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
landlordApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('landlord_access_token') || localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default function LandlordComplete() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    landlordApi.get('/properties/progress/landlord/complete/')
      .then(res => {
        setRows(res.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load data');
        setLoading(false);
      });
  }, []);

  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: 'background.paper', mt: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ color: 'primary.main', fontWeight: 700 }}>
        Completed Ad Fees
      </Typography>
      <Box sx={{ mt: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : rows.length === 0 ? (
          <Typography color="text.secondary">No completed ad fees</Typography>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Student Email</TableCell>
                  <TableCell>Student Name</TableCell>
                  <TableCell>Move-in Date</TableCell>
                  <TableCell>Property Title</TableCell>
                  <TableCell>Property Address</TableCell>
                  <TableCell>Landlord Confirmed</TableCell>
                  <TableCell>Ad Fee</TableCell>
                  <TableCell>Ad Fee Completed Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.user_email}</TableCell>
                    <TableCell>{row.user_full_name}</TableCell>
                    <TableCell>{row.move_in_date || '-'}</TableCell>
                    <TableCell>{row.rental_title}</TableCell>
                    <TableCell>{row.rental_address}</TableCell>
                    <TableCell>
                      {row.landlord_confirmed ? (
                        <span style={{ color: '#388e3c', fontWeight: 600 }}>Confirmed</span>
                      ) : (
                        <span style={{ color: '#f57c00', fontWeight: 600 }}>Pending</span>
                      )}
                    </TableCell>
                    <TableCell>
                      <span style={{ color: '#388e3c', fontWeight: 600 }}>Completed</span>
                    </TableCell>
                    <TableCell>
                      {row.ad_fee_completed_at ? new Date(row.ad_fee_completed_at).toLocaleDateString() : '-'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Paper>
  );
} 